import React from "react";
import { AuthPaymentContainer } from "../misc/auth-payment-container.component";
import { AuthRestartButton } from "../misc/restart-button.component";
import { ReviewDisplayField } from "../misc/review-display-field.component";
import getPaymentDay from "../misc/get-payment-day";
import { formatLastFour, generateLoanDescription } from "../misc/messaging-utils";

export const AuthPaymentRecurringClosedEndSummary = (props) => {
  const subtitle = `Your payment has been successfully submitted. A confirmation email has been sent to email
  address: ${props.confirmationEmail}`;

  return (
    <AuthPaymentContainer title="Payment Summary" subtitle={subtitle}>
      <div className="bold f20 text-centered">
        {`${generateLoanDescription(props.selectedLoan, true)}`}
      </div>
      <div className="my-4 divider"></div>
      <div>
        <ReviewDisplayField title={"First Payment Date"} value={props.firstPaymentDate} />
        <ReviewDisplayField
          title={"Payment Frequency"}
          value={props.paymentFrequency}
          valueClassNames={"minwidth-fit"}
        />
        <ReviewDisplayField
          title={"Payment Day"}
          value={getPaymentDay(props.paymentFrequency, props.firstPaymentDate)}
          valueClassNames={"minwidth-fit"}
          titleColumnSize={"col-md-5"}
          valueColumnSize={"col-md-7"}
        />
        <ReviewDisplayField
          title={"Payment Account"}
          value={`Ending in ${props.paymentAccount}`}
          valueClassNames={"minwidth-fit"}
        />
        <ReviewDisplayField title={"Payment Amount"} value={props.paymentAmount} />
      </div>
      <AuthRestartButton backToLoans={props.backToLoans} bgColor={"#00558c"} />
    </AuthPaymentContainer>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/summary/auth-payment-recurring-closed-end-summary.component.js